import { RootState } from '@/store'
import { getUsers } from '@/store/selectors'

export const getSelectedRoleGuid = (state: RootState) => state.spaceMembersRolesPage.selectedRoleGuid
export const getSortBy = (state: RootState) => state.spaceMembersRolesPage.sortBy
export const getStartIndex = (state: RootState) => state.spaceMembersRolesPage.startIndex || 1
export const getTotalItemsCount = (state: RootState) => state.spaceMembersRolesPage.totalItemsCount

export const mapPaginatedUsers = (state: RootState) => {
  const currentPageUsers = state.spaceMembersRolesPage.users
  if (currentPageUsers) {
    const users = getUsers(state)
    return currentPageUsers.map(userId => {
      return users.byId[userId]
    })
  }
}

export const mapSearchUsers = (state: RootState) => {
  const currentPageUsers = state.spaceMembersRolesPage.searchResults
  if (currentPageUsers) {
    const users = getUsers(state)
    return currentPageUsers.map(userId => {
      return users.byId[userId]
    })
  }
}
